/* Date / relative-time helpers used in the admin UI. */
export function formatDate(iso) {
    if (!iso) return "—";
    try {
        const d = new Date(iso);
        return d.toLocaleString("en-AU", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        });
    } catch {
        return iso;
    }
}

export function formatRel(iso) {
    if (!iso) return "—";
    try {
        const then = new Date(iso).getTime();
        const now = Date.now();
        const s = Math.max(0, Math.floor((now - then) / 1000));
        if (s < 60) return `${s}s ago`;
        if (s < 3600) return `${Math.floor(s / 60)}m ago`;
        if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
        return `${Math.floor(s / 86400)}d ago`;
    } catch {
        return iso;
    }
}
